// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background {
  width: calc(100% - 600px);
  background-size: cover;
}

.inputs-container {
  max-width: 600px;
  padding: 50px;
  min-height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/register-welcome/register-welcome.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,iBAAA;AACF","sourcesContent":[".background {\n  width: calc(100% - 600px);\n  background-size: cover;\n}\n\n.inputs-container {\n  max-width: 600px;\n  padding: 50px;\n  min-height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
